import type { Kitchen } from '@rta/rta-blueprint-library';

export type NeedsBacksplashPageParams = {
	kitchen: Kitchen;
};

export const needsBacksplashPage = (params: NeedsBacksplashPageParams): boolean => {
	const { kitchen } = params;
	const { islands } = kitchen.design;

	for (let i = 0; i < islands.children.length; i++) {
		const island = islands.children[i];
		const countertop = island.getCountertop();
		const backsplashes = countertop?.backsplashes?.children ?? [];

		if (backsplashes.length > 0) {
			return true;
		}
	}

	return false;
};
